module.exports = __webpack_public_path__ + "static/media/javascript.e73667c4.png";